import React from 'react'
import { GiTurnstile } from 'react-icons/gi'
import { useSelector, shallowEqual } from 'react-redux'
import useIsDesktop from './useIsDesktop'
import {Link} from "react-router-dom";

const Logo = () => {
    const { collapsedFlag, dark } = useSelector(
        (state) => ({ collapsedFlag: !!state.config?.collapsed, dark: state.palettes?.background === 'dark' }),
        shallowEqual
    )
    const isDesktop = useIsDesktop()
    // Na mobilu je collapsed=true "menu je otevřené" (off-canvas výsuv), ne "sbalit na ikony" —
    // ikonový režim proto platí jen na desktopu.
    const collapsed = collapsedFlag && isDesktop

    return (
        <Link to={"/dashboard"}>
        <div
            style={{ borderColor: 'rgba(195, 198, 215, 0.3)' }}
            className={`pb-6 border-b mb-4 overflow-hidden ${collapsed ? 'px-3' : 'px-6'}`}
        >
            <div style={{ color: dark ? '#5b8def' : '#004ac6' }}
                className={`text-2xl font-bold flex flex-row items-center ${collapsed ? 'justify-center' : ''}`}
            >
                <GiTurnstile size={collapsed?30:50} className=" flex-shrink-0" style={{ marginRight: collapsed ? 0 : 8 }} />

                {!collapsed && <div className="flex flex-col text-left">
                    <img src={'/icons/enigoo-blue.svg'} className={"ml-2"}/>
                    <p
                        style={{ color: dark ? '#94a3b8' : '#505f76', fontSize: '11px' }}
                        className="font-bold uppercase tracking-wider mt-1 ml-3"
                    >
                        Turnikety
                    </p>
                </div>}
            </div>
            <h1
                style={{ color: dark ? '#5b8def' : '#004ac6' }}
                className={`text-2xl font-bold flex items-center ${collapsed ? 'justify-center' : ''}`}
            >

            </h1>

        </div>
        </Link>
    )
}

export default Logo
